module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chaptitlea"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('strong', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/04_foreword#for"
    }
  }, [_c('em', [_vm._v("Foreword by Dr. Frank P. Varney")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/05_acknowledgements#ack"
    }
  }, [_c('em', [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/06_text#tex"
    }
  }, [_c('em', [_vm._v("A Note on the Text")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/07_introduction#int"
    }
  }, [_c('em', [_vm._v("Introduction: The Vanishing of Vincent")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/08_chapter_01#ch1"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("1")]), _vm._v(" The Strongs and the Vincents: Early Life, Education, and Courtship")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/09_chapter_02#ch2"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("2")]), _vm._v(" Lieutenant Vincent of the Erie Regiment: January to August 1861")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/10_chapter_03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("3")]), _vm._v(" The 83rd Pennsylvania: August 1861 to March 1862")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/11_chapter_04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("4")]), _vm._v(" The Swamps of the Chickahominy: Late March to September 1862")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter_05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("5")]), _vm._v(" Colonel Vincent: October 1862 to January 1863")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter_06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("6")]), _vm._v(" “I Enlisted to Fight”: January to April 1863")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter_07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("7")]), _vm._v(" “I Wish He Were a Brigadier-General”: May to June 1863")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/15_chapter_08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("8")]), _vm._v(" March to Mortality: July 1, 1863")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/16_chapter_09#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("9")]), _vm._v(" The Lion of Round Top: July 2, 1863")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/17_chapter_10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("10")]), _vm._v(" The Road to Immortality: July 3 to July 7, 1863")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/18_chapter_11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("11")]), _vm._v(" The Path to Being Forgotten: The Legacy of Strong Vincent")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/19_appendix#app",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Appendix: The Origins of the “Chamberlain Myth”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/20_bibliography#bib",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/21_notes#not",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Notes")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fe66f35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/02_contents.vue
// module id = 69
// module chunks = 0